import React from "react";
import { DashboardAnalyticsHeader } from "./DashboardAnalyticsHeader";
import { DashboardUserActivityChart } from "./DashboardUserActivityChart";
import { DashboardUserGrowthChart } from "./DashboardUserGrowthChart";
import {
  ActivityDonutItem,
  DashboardTimeFilter,
  DashboardTrend,
  UserGrowthChartPoint,
} from "../types/dashboard-ui.types";

interface DashboardAnalyticsSectionProps {
  timeFilter: DashboardTimeFilter;
  onTimeFilterChange: (value: DashboardTimeFilter) => void;
  trend: DashboardTrend;
  userGrowthChartData: UserGrowthChartPoint[];
  growthLoading: boolean;
  growthError: string | null;
  onRetryGrowth: () => void;
  activityDonutData: ActivityDonutItem[];
  activityLoading: boolean;
  activityError: string | null;
  onRetryActivity: () => void;
}

export const DashboardAnalyticsSection: React.FC<
  DashboardAnalyticsSectionProps
> = ({
  timeFilter,
  onTimeFilterChange,
  trend,
  userGrowthChartData,
  growthLoading,
  growthError,
  onRetryGrowth,
  activityDonutData,
  activityLoading,
  activityError,
  onRetryActivity,
}) => {
  return (
    <>
      <DashboardAnalyticsHeader
        timeFilter={timeFilter}
        onTimeFilterChange={onTimeFilterChange}
      />

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-10">
        <DashboardUserGrowthChart
          loading={growthLoading}
          trend={trend}
          timeFilter={timeFilter}
          chartData={userGrowthChartData}
          error={growthError}
          onRetry={onRetryGrowth}
        />
        <DashboardUserActivityChart
          loading={activityLoading}
          data={activityDonutData}
          error={activityError}
          onRetry={onRetryActivity}
        />
      </div>
    </>
  );
};
